module.exports = __webpack_public_path__ + "img/bonus_symbol_2.fe80d2be.png";